module.exports = __webpack_public_path__ + "img/emoji_firecracker.4972623e.png";